!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = e || self).reactStyleReset = {});
}(this, function (e) {
  "use strict";

  var _t = function t() {
    return (_t = Object.assign || function (e) {
      for (var t, o = 1, i = arguments.length; o < i; o++) {
        for (var n in t = arguments[o]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = {
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    font: "inherit",
    verticalAlign: "baseline"
  },
      i = {
    display: "block"
  },
      n = {
    listStyle: "none"
  },
      r = {
    content: "none"
  },
      a = {
    quotes: "none"
  },
      l = {
    a: o,
    abbr: o,
    acronym: o,
    address: o,
    applet: o,
    article: _t({}, o, i),
    aside: _t({}, o, i),
    audio: o,
    b: o,
    big: o,
    blockquote: _t({}, o, a, {
      "&::after": r,
      "&::before": r
    }),
    body: _t({}, o, {
      lineHeight: 1
    }),
    canvas: o,
    caption: o,
    center: o,
    cite: o,
    code: o,
    dd: o,
    del: o,
    details: _t({}, o, i),
    dfn: o,
    div: o,
    dl: o,
    dt: o,
    em: o,
    embed: o,
    fieldset: o,
    figcaption: _t({}, o, i),
    figure: _t({}, o, i),
    footer: _t({}, o, i),
    form: o,
    h1: o,
    h2: o,
    h3: o,
    h4: o,
    h5: o,
    h6: o,
    header: _t({}, o, i),
    hgroup: _t({}, o, i),
    html: o,
    i: o,
    iframe: o,
    img: o,
    ins: o,
    kbd: o,
    label: o,
    legend: o,
    li: o,
    mark: o,
    menu: _t({}, o, i),
    nav: _t({}, o, i),
    object: o,
    ol: _t({}, o, n),
    output: o,
    p: o,
    pre: o,
    q: _t({}, o, a, {
      "&::after": r,
      "&::before": r
    }),
    ruby: o,
    s: o,
    samp: o,
    section: _t({}, o, i),
    small: o,
    span: o,
    strike: o,
    strong: o,
    sub: o,
    summary: o,
    sup: o,
    table: _t({}, o, {
      borderCollapse: "collapse",
      borderSpacing: 0
    }),
    tbody: o,
    td: o,
    tfoot: o,
    th: o,
    thead: o,
    time: o,
    tr: o,
    tt: o,
    u: o,
    ul: _t({}, o, n),
    var: o,
    video: o
  },
      s = {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
      d = {
    fontFamily: "inherit",
    fontSize: "100%",
    lineHeight: "1.15",
    margin: "0"
  },
      p = {
    WebkitAppearance: "button",
    "&::-moz-focus-inner": {
      borderStyle: "none",
      padding: "0"
    },
    "&:-moz-focusring": {
      outline: "1px dotted ButtonText"
    }
  },
      b = {
    boxSizing: "borderBox",
    padding: "0"
  },
      f = {
    html: {
      lineHeight: "1.15",
      WebkitTextSizeAdjust: "100%"
    },
    body: {
      margin: "0"
    },
    h1: {
      fontSize: "2em",
      margin: "0.67em 0"
    },
    hr: {
      boxSizing: "content-box",
      height: "0",
      overflow: "visible"
    },
    pre: {
      fontFamily: "monospace, monospace",
      fontSize: "1em"
    },
    a: {
      backgroundColor: "transparent"
    },
    "abbr[title]": {
      borderBottom: "none",
      textDecoration: "underline dotted"
    },
    strong: {
      fontWeight: "bolder"
    },
    b: {
      fontWeight: "bolder"
    },
    code: s,
    kbd: s,
    sam: s,
    small: {
      fontSize: "80%"
    },
    sub: {
      bottom: "-0.25em",
      fontSize: "75%",
      lineHeight: "0",
      position: "relative",
      verticalAlign: "baseline"
    },
    sup: {
      fontSize: "75%",
      lineHeight: "0",
      position: "relative",
      top: "-0.5em",
      verticalAlign: "baseline"
    },
    img: {
      borderStyle: "none"
    },
    button: _t({}, d, p, {
      overflow: "visible",
      textTransform: "none",
      WebkitAppearance: "button"
    }),
    input: _t({}, d, {
      overflow: "visible"
    }),
    optgroup: d,
    select: _t({}, d, {
      textTransform: "none"
    }),
    textare: d,
    '[type="button"]': p,
    '[type="reset"]': p,
    '[type="submit"]': p,
    fieldset: {
      padding: "0.35em 0.75em 0.625em"
    },
    legend: {
      boxSizing: "border-box",
      color: "inherit",
      display: "table",
      maxWidth: "100%",
      padding: "0",
      whiteSpace: "normal"
    },
    progress: {
      verticalAlign: "baseline"
    },
    textarea: {
      overflow: "auto"
    },
    '[type="checkbox"]': b,
    '[type="radio"]': b,
    '[type="number"]::-webkit-inner-spin-button': {
      height: "auto"
    },
    '[type="number"]::-webkit-outer-spin-button': {
      height: "auto"
    },
    '[type="search"]': {
      WebkitAppearance: "textfield",
      outlineOffset: "-2px"
    },
    '[type="search"]::-webkit-search-decoration': {
      WebkitAppearance: '""'
    },
    "::-webkit-file-upload-button": {
      WebkitAppearance: "button",
      font: "inherit"
    },
    details: {
      display: "block"
    },
    summary: {
      display: "list-item"
    },
    template: {
      display: "none"
    },
    "[hidden]": {
      display: "none"
    }
  };

  e.default = l, e.normalize = f, e.reset = l, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});